module.exports = __webpack_public_path__ + "static/img/Narthang.d390feb.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/DergeParkhang/Narthang.png
// module id = VUNj
// module chunks = 3